module.exports = __webpack_public_path__ + "img/fabriqblog-original-960.2ce50159.webp";